import { StyleSheet, Text, View } from '@react-pdf/renderer';
import React, { Fragment } from 'react';
import {
	lightInputTextFieldColor,
	primaryColorDark,
	textBoxFontFamily,
	textBoxFontSize
} from './PDFStyles';

const styles = StyleSheet.create({
	textBox: {
		fontSize: textBoxFontSize,
		textAlign: 'left',
		fontFamily: textBoxFontFamily,
		backgroundColor: lightInputTextFieldColor,
		paddingHorizontal: 5,
		color: primaryColorDark,
		fontWeight: 400
	}
});

export const SectionedText = ({ data, debug = false }: { data: any, debug?: boolean }) => (
	<Fragment>
		{data && data.split(/\n/g).map((text: any) => (
			<View style={styles.textBox} debug={debug} wrap={false}>
				<Text>{text + '\n'}</Text>
			</View>
		))}
	</Fragment>
);
